import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import DataTable from "../core/ui/data-table";
import SessionContext from "SessionContext";
import ConfirmSuccess from "../core/ui/confirm-success";
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';

function SuppressInvoiceCategory() {
    const history = useHistory();
    const session = useContext(SessionContext);

    const [tableKey, setTableKey] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);

    const table_columns = [
      { header: "Invoice Category Name", key: "invoice_category_name", render: (val) => {
        return <span key={val.am_invoice_category.id}>{val.am_invoice_category.name}</span>
      } },
      { header: "Invoice Category Description", key: "invoice_category_desc", render: (val) => {
        return <span key={val.am_invoice_category.id}>{val.am_invoice_category.description}</span>
      } },
      { header: "Invoice Category Channel Options", key: "invoice_category_channel_options", render: (channels) => {
        if(
          !channels.am_invoice_category.channel_options || 
          !channels.am_invoice_category.channel_options.length) {
          return <span>None</span>
        }
        return channels.am_invoice_category.channel_options.map((option) => {
          return <span key={option.id}><span>&bull; {option.name}</span><br /></span>
        })
      } },
      { header: "Suppressed Invoice Name", key: "suppressed_invoice_category_name", render: (val) => {
        return <span key={val.suppressed_am_invoice_category.id}>{val.suppressed_am_invoice_category.name}</span>
      } },
      { header: "Suppressed Invoice Description", key: "suppressed_invoice_category_desc", render: (val) => {
        return <span key={val.suppressed_am_invoice_category.id}>{val.suppressed_am_invoice_category.description}</span>
      } },
      { header: "Suppressed Invoice Channel Options", key: "suppressed_invoice_category_channel_options", render: (channels) => {
        if(
          !channels.suppressed_am_invoice_category.channel_options || 
          !channels.suppressed_am_invoice_category.channel_options.length) {
          return <span>None</span>
        }
        return channels.suppressed_am_invoice_category.channel_options.map((option) => {
          return <span key={option.id}><span>&bull; {option.name}</span><br /></span>
        })
      } },
    ];
  
    const table_actions = (item) => (
      <ul id="action-menu" className="action-menu">
        <li>
        <button type="button" className="btn btn-link btn-sm" onClick={() => onClickEdit(item)}>
          <i className="bi bi-pencil"></i> Edit</button>
        </li>
        <li>&nbsp;</li>
        <li>
          <button type="button" className="btn btn-link btn-sm" onClick={() => onClickDelete(item)}>
            <i className="bi bi-trash"></i> Delete</button>
        </li>
      </ul>
    );

    function onClickEdit(val) {
      history.push("/admin-suppress-invoice-form#id=" + val.id);
    }

    function onClickDelete(val) {
      setItemToDelete(val);
      setDeleteModalOpen(true);
    }

    function onFinalizeDelete() {
      setDeleteModalOpen(false);
      session.command('admin/delete_invoice_category_suppression', itemToDelete.id, {}, { defaultErrorHandling: false })
      .then(() => { 
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          setTableKey(!tableKey);
        }, 2000);
      })
      .catch((err)=>{
        console.log("Suppressed Invoice Category Update Failed", err) 
      });
    }
  
    function onClickBack() {
      history.push("/admin-invoice-categories");
    }
  
    function onClickNew() {
      history.push("/admin-suppress-invoice-new-form");
    }
  
    return (
      <div className="page admin-page admin-invoice-categories-page">
        <div className="list-header sticky-page-header">
          <button className="new-button" onClick={onClickBack}>
            <i className="bi bi-chevron-left"></i> Back
          </button>
          <h1>Suppress Invoice Categories</h1>
          <i className="spacer" />
          <button className="new-button" onClick={onClickNew}>
            New Suppression
          </button>
        </div>
        <div key={tableKey}>
          <DataTable
            query="admin/invoice_category_suppression_list"
            cols={table_columns}
            actions={table_actions}
            empty="No Suppressions Found"
            params={{
              sort_asc: true
            }}
          />
        </div>
        <ConfirmSuccess show={showSuccess} label="Suppressed Invoice Deleted." />
        <Modal
          isOpen={deleteModalOpen}
        >
          <ModalHeader>
            Delete Suppressed Invoice
          </ModalHeader>
          <ModalBody>
            <Alert color="light" className="d-flex">
              <i className="bi bi-exclamation-octagon"></i>
              <div>
                Selecting <b>delete</b> will permanently remove all instances from AudienceMaker and cannot be undone. Are you sure you want to continue?
              </div>
           </Alert>
          </ModalBody>
          <ModalFooter>
            <button onClick={() => setDeleteModalOpen(false)}>Close</button>
            <button className="promote" onClick={onFinalizeDelete}>Delete</button>
          </ModalFooter>
        </Modal>
      </div>
    );
}

export default SuppressInvoiceCategory;
